import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 少額リース判定基準(日本基準) */
enum SmallLeaseJudgeCriteriaJapan {
  threeMillionYenBasis = '1',
  fiveThousandDollarBasis = '2',
}

const nameConfig = {
  threeMillionYenBasis: new Map([[Locale.ja, '300万円基準']]),
  fiveThousandDollarBasis: new Map([[Locale.ja, '5000米ドル基準']]),
};

const toEnum = rawValueToEnum(
  SmallLeaseJudgeCriteriaJapan,
  SmallLeaseJudgeCriteriaJapan.threeMillionYenBasis,
);
const toDisplay = enumToName(SmallLeaseJudgeCriteriaJapan, nameConfig);
const toDisplayWithPrefix = enumToName(SmallLeaseJudgeCriteriaJapan, nameConfig, { prefix: true });

export const smallLeaseJudgeCriteriaJapan = {
  enum: SmallLeaseJudgeCriteriaJapan,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { SmallLeaseJudgeCriteriaJapan };
